import { ReportingControllerBaseConfig } from '../../../base';
import { RecordNewController } from './recordNewInterface';
import { RecordNewViewProps } from './recordNewProps';
import { RecordFormController } from '../form';

export function createRecordNewController(
    config: Omit<ReportingControllerBaseConfig, 'controller'> & {
        controller: {
            record: {
                form: RecordFormController;
            };
        };
    }
): RecordNewController {
    const {
        controller: {
            record: { form: recordFormController },
        },
    } = config;
    return {
        useProps(context, item, props): RecordNewViewProps {
            const form = recordFormController.useProps(context, item.form, props.form);
            return {
                title: 'New record',
                form,
            };
        },
    };
}
